export const GET_INITIAL_SHIFT = 'employee@get-initial-shifts';
export const UPDATE_EMPLOYEE_SHIFT = 'employee@update-shifts';
export const GET_EMPLOYEE_INFO = 'employee@get-employee-info';
export const UPDATE_EMPLOYEE_INFO = 'employee@update-employee-info';
